import { render, staticRenderFns } from "./CompositionCellRenderer.vue?vue&type=template&id=2bad06f9&scoped=true"
import script from "./CompositionCellRenderer.vue?vue&type=script&lang=ts"
export * from "./CompositionCellRenderer.vue?vue&type=script&lang=ts"
import style0 from "./CompositionCellRenderer.vue?vue&type=style&index=0&id=2bad06f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad06f9",
  null
  
)

export default component.exports